// eslint-disable-next-line
// new 2020-06
// https://cli.vuejs.org/guide/browser-compatibility.html#polyfills
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer'; // polyfill for lozad
// babel/polyfill is deprecated
// https://babeljs.io/docs/en/babel-polyfill
// https://cli.vuejs.org/guide/browser-compatibility.html#usebuiltins-


import Vue from 'vue';

// import { sync } from 'vuex-router-sync';
import cookies from 'js-cookie';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta';
// import schema from '@/schema/index.js';

// import $ from 'jquery';
import 'bootstrap';
import _ from 'lodash';
// import uuid from 'uuid/v4';

import VueLazyload from 'vue-lazyload';
// import Rollbar from 'vue-rollbar';

// forms
// added by marksun
// import VueInputMask from 'vue-inputmask';
// import VueTheMask from 'vue-the-mask';
// https://www.npmjs.com/package/v-mask
import VueMask from 'v-mask';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
// import fileSize from 'filesize';

import VueClipboard from 'vue-clipboard2';

// me-modules
import meHelper from '@motionelements/helper';

// by steve/marksun for product 2020-06
// import * as tools from '@/tools/index.js';
import player from '@motionelements/helper/player/index.js';

// import { SpinnerPlugin } from 'bootstrap-vue';

// eslint-disable-next-line
import { VBScrollspyPlugin, TablePlugin, DropdownPlugin, TooltipPlugin } from 'bootstrap-vue';
import VTooltip from 'v-tooltip';

import link from '@motionelements/core/src/helpers/link.js';
// init services store
import { setStore as setAccountServiceStore } from '@motionelements/core/src/services/account.service.js';
import { setStore as setAppServiceStore } from '@motionelements/core/src/services/app.service.js';
import { EventBus } from '@motionelements/core/src/services/event-bus.service.js';
import { setStore as setNotificationServiceStore } from '@motionelements/core/src/services/notification.service.js';
import { setStore as setApiStore } from '@motionelements/core/src/api/base-api-v2';
import { setStore as setLanguageStore } from '@motionelements/core/src/services/language.service.js';


import 'prismjs';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-bash';
// import 'prismjs/themes/prism-okaidia.css';
// import '@/assets/scss/prismjs/themes/prism-vsc.dark-plus.css';
import '@/assets/scss/prismjs/themes/prism-vs.css';

import Rollbar from 'vue-rollbar';
import App from './App.vue';
import router from './router/index.js';
import store from './store';

// import iconFont from '@motionelements/assets/src/js/me-font/icons-product.js';
import iconFont from './assets/js/me-font/icons-demo.js';

import i18n from './lang/i18n.js';

const isProduction = process.env.VUE_APP_ENV === 'production';

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 2,
});

Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  hostSafeList: ['motionelements.com', 'cloudfront.net'],
  captureUncaught: !isProduction,
  captureUnhandledRejections: !isProduction,
  verbose: !isProduction,
  enabled: false,
  environment: process.env.VUE_APP_ENV,
});

Vue.use(iconFont);
Vue.use(VueMeta, {
  keyName: 'head', // compatible with Nuxt
  tagIDKeyName: 'hid', // compatible with Nuxt
});
// added by marksun
//     "vue-inputmask": "^0.2.1",
// Vue.use(VueInputMask.default);
// Vue.use(VueTheMask);
// https://www.npmjs.com/package/v-mask
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VueScrollTo, { duration: 800 });

Vue.use(VBScrollspyPlugin);
Vue.use(TablePlugin);
Vue.use(DropdownPlugin);
// Vue.use(TooltipPlugin);
Vue.use(VTooltip, {
  defaultTrigger: 'click hover',
});


// VueClipBoard need this setting in modal
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.prototype.$VueBus = new Vue();


Object.defineProperty(Vue.prototype, '$locale', {
  get() {
    return i18n.locale;
  },
  set(locale) {
    i18n.locale = locale;
  },
});

setAccountServiceStore(store);
setAppServiceStore(store);
setNotificationServiceStore(store);
setApiStore(store);
setLanguageStore(store);


Vue.prototype._ = _;
// eslint-disable-next-line no-underscore-dangle
Vue.prototype.$_ = _; // use $_ for Nuxt compatiblity
Vue.prototype.$axios = axios;
Vue.prototype.$cookies = cookies;

Vue.prototype.$audioPlayer = player.audioPlayer;
Vue.prototype.$videoPlayer = player.videoPlayer;
Vue.prototype.$videoPlayerSettings = player.videoPlayerSettings; // split normal video player and need change settings, ex: gif-creator
Vue.prototype.$bus = EventBus;

Vue.prototype.$scrollToTop = () => window.scrollTo({ top: 0 });
Vue.prototype.$scrollTo = (selector) => { document.querySelector(selector).scrollIntoView({ behavior: 'smooth' }); };

// Vue.prototype.$schema = schema;
Vue.prototype.$term = meHelper.term;
Vue.prototype.$siteUrl = meHelper.siteUrl;
Vue.prototype.$site = meHelper.site;

Vue.prototype.$link = link;

Vue.config.productionTip = true;
Vue.config.devtools = !isProduction;
Vue.config.performance = !isProduction;


Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
